import { StLine, StSelect } from '@components/common';
import styled from 'styled-components';

const StUl = styled.ul`
  line-height: 1em;
`;

const Useritem = styled.li`
  display: grid;
  grid-template-columns: 1fr 90px;
  align-items: center;
  height: 64px;
  :hover {
    background-color: ${(props) => props.theme.colors.focus};
  }
`;

const HeaderItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 90px;
  align-items: center;
  height: 2em;
`;

const StP = styled.p`
  padding: 1em;
  color: ${(props) => props.theme.colors.text};
`;

const HeaderEmail = styled.p`
  padding-left: 1em;
  color: ${(props) => props.theme.colors.text};
`;

const HeaderRole = styled.p`
  text-align: center;
  color: ${(props) => props.theme.colors.text};
`;

const Empty = styled.p`
  padding: 3em 1em;
  text-align: center;
  color: ${(props) => props.theme.colors.text};
  opacity: 0.6;
`;

interface vUserListProps {
  users: Array<User>;
  roles: Array<string>;
  each: (user: User) => {
    username: string;
    userRole: string;
    handleChange: React.ChangeEventHandler<HTMLSelectElement>;
  };
}

const VUserList = ({ users, roles, each }: vUserListProps): JSX.Element => {
  return (
    <>
      <HeaderItem>
        <HeaderEmail>이메일</HeaderEmail>
        <HeaderRole>역할</HeaderRole>
      </HeaderItem>
      <StLine />
      <StUl>
        {users?.map((user, idx) => {
          const { username, userRole, handleChange } = each(user);
          return (
            <div key={'user_item_' + username}>
              <Useritem>
                <StP>{username}</StP>
                <StSelect onChange={handleChange} value={userRole}>
                  {roles.map((role) => {
                    return <option key={idx + role}>{role}</option>;
                  })}
                </StSelect>
              </Useritem>
              <StLine />
            </div>
          );
        })}
      </StUl>
      {users?.length === 0 ? <Empty>조회된 사용자가 없습니다.</Empty> : null}
    </>
  );
};

export default VUserList;
